import axios from "axios";

const client = axios.create({
    //baseURL: "http://localhost:8000/auth"
    baseURL: "https://vp-backend-ysy4bqirgq-uc.a.run.app/auth" 
});

export const getTokens = async (body) => {
    const promise = client.post('/generate_tokens', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response.data);
    return data;
};

export const refreshTokens = async (body) => {
    const promise = client.post('/refresh_tokens', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response.data);
    return data;
};